module.exports = __webpack_public_path__ + "62ac62beb54afceb2a5bffc8007cfcdb.png";